import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Walk = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M16 5C14.8954 5 14 5.89543 14 7C14 8.10457 14.8954 9 16 9C17.1046 9 18 8.10457 18 7C18 5.89543 17.1046 5 16 5ZM12 7C12 4.79086 13.7909 3 16 3C18.2091 3 20 4.79086 20 7C20 8.23777 19.4378 9.34423 18.5548 10.078C18.5662 10.0812 18.5776 10.0846 18.5889 10.0881C18.9569 9.92227 19.4047 9.99053 19.7071 10.2929L24.7071 15.2929C25.0976 15.6834 25.0976 16.3166 24.7071 16.7071C24.3166 17.0976 23.6834 17.0976 23.2929 16.7071L20 13.4142V19C20 19.7059 19.6343 20.3264 19.082 20.6824L19.9939 28.8896C20.0549 29.4385 19.6593 29.9329 19.1104 29.9939C18.5615 30.0549 18.0671 29.6593 18.0061 29.1104L17.105 21H14.895L13.9939 29.1104C13.9329 29.6593 13.4385 30.0549 12.8896 29.9939C12.3407 29.9329 11.9451 29.4385 12.0061 28.8896L12.918 20.6824C12.3657 20.3264 12 19.7059 12 19V13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L12.2929 10.2929C12.5953 9.99053 13.0431 9.92227 13.4111 10.0881C13.4224 10.0846 13.4338 10.0812 13.4452 10.078C12.5622 9.34423 12 8.23777 12 7ZM14 12V19H18V12H14Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Walk;
